export default {
  ColumnContainer: 'ColumnContainer',
  SectionContainer: 'SectionContainer',
  ReCaptchaElementBlock: 'ReCaptchaElementBlock',
}
